var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudent30(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M333.03+263.701L289.642+523.447L718.891+530.107L698.065+255.376",
    fill: "#774d12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "",
    opacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe94b",
    d: "M876.999+915.886L183.402+915.886C165.861+915.886+152.367+901.685+153.262+884.167L167.853+598.697C167.853+527.055+232.424+483.214+281.359+478.515L413.788+469.661L622.622+469.234L747.281+478.515C808.61+483.214+860.787+527.055+860.787+598.697L876.999+915.886Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#fcd08c",
    d: "M511.722+110.569L519.278+110.569C617.868+110.569+697.791+196.81+697.791+303.194L697.791+303.194C697.791+409.578+617.868+495.819+519.278+495.819L511.722+495.819C413.131+495.819+333.208+409.578+333.208+303.194L333.208+303.194C333.208+196.81+413.131+110.569+511.722+110.569Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.641+350.256L518.054+350.256C575.632+350.256+622.309+400.324+622.309+462.085L622.309+462.085C622.309+523.847+575.632+573.914+518.054+573.914L513.641+573.914C456.062+573.914+409.386+523.847+409.386+462.085L409.386+462.085C409.386+400.324+456.062+350.256+513.641+350.256Z",
    fill: "#fcd08c",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#774d12",
    d: "M510.369+92.3276L523.364+92.6767C634.255+95.6557+712.433+187.757+708.985+306.185C708.985+306.185+670.304+271.918+612.527+256.624C577.719+247.411+536.976+137.366+536.976+137.366C536.976+137.366+529.756+223.827+515.409+241.532C506.835+252.114+486.809+259.879+498.106+241.853C512.562+218.788+512+182.274+512+182.274C512+182.274+505.335+233.511+480.512+252.761C471.225+259.963+449.147+259.172+459.029+251.512C489+228.281+471.858+198.957+471.858+198.957C471.858+198.957+458.177+259.66+419.839+256C370.715+256.624+320.426+319.835+322.161+302.674C323.896+285.514+324.123+273.435+326.69+259.512C344.655+162.052+413.34+89.721+510.369+92.3276Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent30);
export default __webpack_public_path__ + "static/media/Student 30.8e371208c67102f76c48083cfa584d04.svg";
export { ForwardRef as ReactComponent };